import { render, staticRenderFns } from "./VersionRule.vue?vue&type=template&id=453d14b7&scoped=true"
import script from "./VersionRule.vue?vue&type=script&lang=js"
export * from "./VersionRule.vue?vue&type=script&lang=js"
import style0 from "./VersionRule.vue?vue&type=style&index=0&id=453d14b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d14b7",
  null
  
)

export default component.exports